<template>
  <div class="pages">
    <div class="content">
      <img src="/static/product/icn_ytj.png" class="tImg" />
      <div class="t-c">{{ $t('main.PayedToDertail') }}</div>
      <div class="t-x">{{ $t('main.OrderNumber') }}:{{snNum}}</div>
      <div class="facac t-b">
        <div class="f-l" @click="gotoIndex">{{ $t('main.goHome') }}</div>
        <div class="f-r" @click="gotoDetail">{{ $t('main.productDetail') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { confirmOrder,getHetong, listDetailOrder } from "@/api/order";
export default {
  data() {

    return {
      snNum: "",
    }
  },
  created() {
    //获取订单号

   // console.log("成功页面订单号",this.$route.query.sn);
    this.snNum = this.$route.query.sn

    // this.init()
  },

  methods: {

    searchPayStatus() {
      let params = {
        req: {
          sn: this.$route.query.sn
        }
      }
      listDetailOrder(params).then(res => {
        if(res.rsp.code === 0) {
          this.hetongid = res.data.contract_id;
          this.orderNum = res.data.sn;
          this.orderStatus = res.data.status;
          this.orderTotalPrice = res.data.total_price;
          this.orderType = res.data.order_type;
          this.getHetonginf(); //查询收获地址显示
          this.isCN = this.$i18n.locale === "zn";

          // TODO 如果是成功跳转  关闭轮询
          // this.$router.push("/userCenter");
          // '/'
        }
      })
    },
    // 去首页
    gotoIndex(){
      this.$router.push("/");
    },

    // 查看详情
    gotoDetail() {
      // console.log(orderid)
      this.$router.push({ path: '/userCenter/orderdetail', query: { id: this.snNum } })
    },

  }
}

</script>

<style scoped lang="less">
.pages {
  min-height: 100%;
  background-color: #fff;
  .content {
    border: 1px solid #f2f2f2;
    text-align: center;
    .tImg {
      width: 15rem;
      height: 11.25rem;
    }
    .t-c {
      font-size: 1.285rem;
      color: #000000;
      max-width: 880px;
      margin: 2rem auto;
    }
    .t-x {
      color: #000000;
      margin-top: 1.25rem;
    }
    .t-b {
      margin-top: 2rem;
      .f-l {
        height: 2.5rem;
        line-height: 2.5rem;
        padding: 0 1rem;
        border: 1px solid #cccccc;
        border-radius: 4px;
        color: #999999;
        cursor: pointer;
      }
      .f-r {
        height: 2.5rem;
        padding: 0 1rem;
        line-height: 2.5rem;
        background: #635796;
        border-radius: 4px;
        margin-left: 1.25rem;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
  @media screen and (max-width: 1400px) {
    .content {
      padding: 3.5rem 2%;
    }
  }
  @media screen and (min-width: 1400px) {
    .content {
      padding: 3.5rem 10%;
    }
  }
  @media screen and (min-width: 1700px) {
    .content {
      padding: 3.5rem 15%;
    }
  }
}
</style>
